import React, { useState, useEffect } from "react";

interface DeveloperSearchInputProps {
  placeholder?: string;
  onSearch: (term: string) => void;
  initialValue?: string;
}

const DeveloperSearchInput: React.FC<DeveloperSearchInputProps> = ({
  placeholder,
  onSearch,
  initialValue = "",
}) => {
  const [searchTerm, setSearchTerm] = useState(initialValue);

  useEffect(() => {
    setSearchTerm(initialValue);
  }, [initialValue]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  const handleClear = () => {
    setSearchTerm("");
    onSearch("");
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <div className="flex items-center border rounded-lg overflow-hidden">
        <span className="p-2 text-gray-500">
          <i className="fa fa-search"></i>
        </span>

        <input
          type="text"
          value={searchTerm}
          onChange={handleInputChange}
          placeholder={placeholder || "Search by project name..."}
          className="w-full p-2 outline-none"
        />

        {searchTerm && (
          <button
            type="button"
            onClick={handleClear}
            className="p-2 text-red-500 hover:text-red-700"
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
};

export default DeveloperSearchInput;
